<template>
	<div class="head">
		<div el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 1, 39, 0.8)">
			<el-container>
				<el-header height='160px'>
					<div class="upper">
						<el-row>
							<el-col :span="12">
								<div class="time">
									{{ nowTime }} 星期{{ week | getweek }}
								</div>
							</el-col>
							<el-col :span="12">
								<div class="button">
									<el-row>
										<el-row>
											<el-col :span="8">
												<!-- <div style="width: 100px;text-align: center;">
													<img src="../assets/home.png" />
												</div> -->
											</el-col>
											<el-col :span="8">
												<!-- <div style="width: 100px;text-align: center;">
													<img src="../assets/screen.png" />
												</div> -->
											</el-col>
											<el-col :span="8">
												<div style="width: 100px;text-align: center;" @click="returns()">
													<img src="../assets/return.png" />
												</div>
											</el-col>
										</el-row>
									</el-row>
								</div>
							</el-col>
						</el-row>
					</div>
				</el-header>
				<el-main>
					<div class="lowerpart">
						<el-row>
							<el-col :span="9">
								<div class="boxlift">
									<div class="boxliftup">
										<div class="boxup">
											<el-row>
												<el-col :span="2" class="ioc" />
												<el-col :span="22" class="tieletext">
													履职图片
												</el-col>
											</el-row>
											<div style="margin-top: 2%;">
												<el-carousel :interval="4000" indicator-position='none' type="card"
													height="200px">
													<el-carousel-item v-for="item in Image">
														<img style="width: 100%;height: 100%;" :src="item.img" />
													</el-carousel-item>
												</el-carousel>
											</div>
										</div>
									</div>
									<div class="boxliftmiddle">
										<div class="boxup">
											<el-row>
												<el-col :span="2" class="ioc" />
												<el-col :span="22" class="tieletext">
													代表今日履职动态数据
												</el-col>
											</el-row>
										</div>
										<div class="boxdow">
											<el-row>
												<el-col :span="17" class="lvzhidt">
													<div class="lzboxone" style="margin-top: 10px;">
														<div>发布话题：</div>
														<div class="textsiz">11</div>
														<div>个</div>
														<div class="textsizbox">29</div>
														<div>人次参与讨论</div>
													</div>
													<div class="lzboxone" style="margin-top: -20px;">
														<div>发布动态：</div>
														<div class="textsiz">31</div>
														<div>个</div>
														<div class="textsizbox">55</div>
														<div>人次互动</div>
													</div>
												</el-col>
												<el-col :span="5" style="margin-left: 5%;">
													<div class="lzboxup">
														<div style="text-align: center;width: 100%;margin-top: 10px;">
															登录人数</div>
													</div>
													<div class="lzboxup">
														<div class="sizsz">
															5
														</div>
														<div class="sizsz">
															3
														</div>
													</div>
												</el-col>
											</el-row>
										</div>
									</div>

									<div class="boxliftdown" @click="geturl()">
										<dv-scroll-board :config="benefit"
											style="width:90%;height:400px;margin-left: 5%;" />
									</div>
								</div>

							</el-col>
							<el-col :span="15">
								<div class="middlebox">

									<el-row>
										<el-col :span="12" v-for="item,index in listdata">
											<div class="boxlift">
												<div class="middleup">
													<div class="titlebox">
														<el-row>
															<el-col :span="2" class="ioc" />
															<el-col :span="22" class="tieletext">
																{{item.tit}}
															</el-col>
														</el-row>
													</div>
													<div :id="'main_' + index" style="width: 100%;height:360px;" />
												</div>
											</div>
										</el-col>
									</el-row>

								</div>
							</el-col>

						</el-row>
					</div>
				</el-main>
			</el-container>
		</div>

	</div>
</template>

<script>
	import moment from 'moment';
	import * as echarts from 'echarts';
	import axios from 'axios';
	import {
		getport
	} from '@/api/api'
	export default {
		data() {
			return {
				nowTime: '',
				week: '',
				loading: true,
				listdata: [{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					},
					{
						siza: [],
						data: [],
						tit: '',
					}
				],


				Image: [{
						img: 'https://rdscreen.wkyyds.xyz/img/e.jpg'
					},
					{
						img: 'https://rdscreen.wkyyds.xyz/img/a.jpg'
					},
					{
						img: 'https://rdscreen.wkyyds.xyz/img/j.jpg'
					}, {
						img: 'https://rdscreen.wkyyds.xyz/img/i.jpg'
					}, {
						img: 'https://rdscreen.wkyyds.xyz/img/lnhg2.png'
					},

				],
				benefit: {
					rowNum: '6',
					data: [
						['09:23', '郑月明参加了一次调研视察'],
						['10:35', '张民参加了一次学习培训'],
						['10:24', '张民参加了一联系群众'],
						['11:34', '市人大代表巩延岳完成了一次述职报告'],
						['15:43', '郑月明参加了一次人大会议'],
						['19:51', '郑月明参加了一次双联活动'],
						['07:29', '梁刚参与了一个话题'],
						['17:23', '张民发表了一条评论'],

					],
					oddRowBGC: 'transparent',
					evenRowBGC: 'transparent',
				}
			}
		},
		created() {
            this.getCurrentTime()
			this.getbuzhidao()
		},
		filters: {
			getweek(e) {
				var week = ['一', '二', '三', '四', '五', '六', '日']
				return week[e - 1]
			},
		},
		mounted() {
			this.getlvzhi()
		},
		methods: {
			geturl() {
				window.open(
					"https://fs4qpg.aliwork.com/APP_DK5J8DN5B0JVMFQ00NH3/custom/FORM-EA866E71EA8AJRPT9UJ8F84SULVR2H1WDSMHLZ1?corpid=ding06bac9c9cc08bf4a24f2f5cc6abecb85&id=FINST-LEA66TA10APAKOBPEHH1RBVA4GQR37IJDQMHLZ23",
					"_self");
			},
			getCurrentTime() {
				this.nowTime = moment().format('YYYY年MM月DD日')
				this.week = moment().format('E')
			},
			returns() {
				this.$router.replace({
					path: '/'
				});
			},
				
			getlvzhi() {
				let path = '?id=14'
				getport('', path).then(res => {
					// console.log(res.data,'镇街数据')
					var j=0;
					for(var i=0;i<21;i++)
					{
						 this.listdata[i].data = JSON.parse('[' + res.data[j][0] + ']')
						 j++;
						 this.listdata[i].siza = JSON.parse('[' + res.data[j] + ']')
						 j++;
						 // console.log(this.listdata[i].siza,'siza',res.data[j],'=====')
						 this.listdata[i].tit = res.data[j][0]
						 j++;
					}
					// console.log(this.listdata,'数据')
					this.myEcharts()
					this.loading = false
				})
			},
			getbuzhidao() {
				let path = '?id=15'
				getport('', path).then(res => {
					// const data1 = res.symbol
					console.log(res.data)
					
				})
			},
			//echats配置
			myEcharts() {
				this.listdata.forEach((item, index) => {
					var myChart = echarts.init(document.getElementById('main_' + index));
					// 绘制柱状图表
					myChart.setOption({
						xAxis: {
							type: 'category',
							data: item.data,
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},

							axisLabel: {
								show: true,
								color: '#ffffff',
								fontSize: 15,
								interval: 0,
								width: 30,
								overflow: "breakAll"
							},
						},
						yAxis: {
							axisLabel: {
								show: true,
								color: '#ffffff',
								fontSize: 12,

							},
							type: 'value',
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: true,
								lineStyle: {
									// type: 'dashed', //默认实线，dashed虚线
									width: 1,
									color: '#082592',
								}
							},
						},
						series: [{
							data: item.siza,
							type: 'bar',
							barWidth: '40%',
							itemStyle: { //
								normal: {
									color: new echarts.graphic.LinearGradient(
										0, 0, 0, 1,
										[{
												offset: 0.5,
												color: '#0079FF'
											},
											{
												offset: 1,
												color: '#340FD2'
											}
										]
									),

									// barBorderRadius: [6, 6, 6, 6]
								},

							},
							name: 'Life Cost',
							type: 'bar',
							stack: 'Total',
							label: {
								show: true,
								position: 'top',
								textStyle: { //数值样式
									color: '#00FFD7',
									fontSize: 12
								}
							},


						}]
					})
				})
			},

		}
	}
</script>

<style scoped>
	body {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000127;

	}

	.boxcorle {
		width: 100%;
		height: 100%;
		/* border: 5px solid #A3D6FF; */
	}

	.boxup {
		width: 100%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
	}

	.boxdow {
		width: 100%;
		height: 140px;
		/* border: 3px solid #00ff00; */
	}

	.tieletext {
		height: 30px;
		font-size: 19px;
		font-weight: 550;
		line-height: 30px;
		background-image: -webkit-linear-gradient(bottom, #A3D6FF, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.upper {
		width: 1835px;
		padding: 30px 0 0 0;
		position: relative;
		background-size: contain;
		height: 160px !important;
		background: url('../assets/tieliepng.png') no-repeat center;
	}

	.lowerpart {
		width: 1835px;
		height: 870px !important;
		/* border: 1px solid #aa0000; */
	}

	.middlebox {
		width: 95%;
		margin-left: 5%;
		height: 870px !important;
		height: calc(100vh - 200px);
		overflow-y: auto;
		background: url('../assets/twobj.png') no-repeat center;
		border-radius: 6px;
	}

	.middleboxtwo {
		width: 100%;
		height: 870px !important;
	}

	.boxliftup {
		width: 100%;
		height: 260px;
		/* border: 1px solid #fff; */
		color: #fff;


	}

	.titlebox {
		width: 100%;
		margin-top: 30px;
	}

	.boxliftmiddle {
		width: 100%;
		height: 170px;
		border: 1px solid #5AE9FF;
	}

	.boxliftdown {
		margin-top: 30px;
		width: 100% !important;
		border: 1px solid #5AE9FF;
	}

	.middleup {
		width: 100%;
		/* height: 435px; */
		/* border: 1px solid #fff; */
	}

	.rithbox {
		width: 100%;
		height: 870px !important;
		/* border: 1px solid #aa0000; */
	}

	.boxlift {
		width: 100%;
		/* height: 435px !important; */
		/* border: 1px solid #aa0000; */
	}

	.time {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-left: 5%;
		margin-top: 50px;
		line-height: 40px;
		/* border: 1px solid #aa0000; */
	}

	.button {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-top: 70px;
		margin-left: 55%;
		line-height: 40px;
		display: flex;
		justify-content: center;
	}

	.ioc {
		height: 30px;
		background: url('../assets/ioc.png') no-repeat center;
	}

	.lvzhidt {
		height: 140px;
		/* border: 1px solid #aa0000; */
	}

	.textsiz {
		color: #00aaff;
		font-size: 22px;
		font-weight: 600;
	}

	.textsizbox {
		margin-left: 20px;
		color: #00aaff;
		font-size: 22px;
		font-weight: 600;
	}

	.lzboxup {
		width: 95%;
		height: 70px;
		color: #fff;
		display: flex;
		margin-left: 5%;
		font-size: 17px;
		line-height: 70px;
		display: flex;
		justify-content: center;
		/* border: 1px solid #aa0000; */
	}

	.lzboxone {
		width: 95%;
		height: 70px;
		color: #fff;
		display: flex;
		margin-left: 5%;
		font-size: 17px;
		line-height: 70px;

		/* border: 1px solid #aa0000; */
	}

	.sizsz {
		width: 100%;
		width: 28px;
		height: 48px;
		font-size: 28px;
		margin-top: -5px;
		margin-left: 4px;
		font-weight: 600;
		line-height: 60px;
		text-align: center;
		background: url('../assets/bjsizi.png') no-repeat center;
		background-size: 100% 100%;

	}

	/* 1,滚动条 */
	::-webkit-scrollbar {
		width: 5px;
		/* 纵向滚动条 宽度 */
		height: 15px;
		/* 横向滚动条 高度 */
		background: #62C2FF;
		/* 整体背景 */
		border-radius: 10px;
		/* 整体 圆角 */
	}

	/* 4.内层轨道，它会覆盖外层轨道的样式。 */
	::-webkit-scrollbar-track-piece {
		width: 5px;
		background-color: #ffffff;
		margin: 0 -2px 0;
		border-radius: 10px;
	}

	/* 5,滑块 */
	::-webkit-scrollbar-thumb {
		background: #62C2FF;
		min-height: 0px;
		min-width: 50px;
		border-radius: 10px;
	}


	/* tmd嗯改样式 */
	/deep/.row-item {
		border-bottom: 1px dashed #5AE9FF !important;
		font-size: 16px !important;
	}

	/deep/.dv-scroll-board {
		color: #b1b1b1 !important;
	}
</style>
<!-- <style>
	body {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000128;
	}
</style> -->